import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

// shadcn convention — combine class names + resolve Tailwind conflicts.
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
